/**
 * Shared visual tokens for the dashboard (single source of truth).
 */
/** Matches `:root` --theme-primary / --theme-primary-light in `index.css` */
export const THEME_PRIMARY = "#1976d2";
export const THEME_PRIMARY_LIGHT = "#e3f2fd";

export const dash = {
  pageBg: "#ffffff",
  surface: "#ffffff",
  border: "rgba(15, 23, 42, 0.08)",
  borderStrong: "rgba(15, 23, 42, 0.12)",
  textMuted: "rgba(15, 23, 42, 0.55)",
  accent: THEME_PRIMARY,
  accentSoft: "rgba(25, 118, 210, 0.08)",
  shadowSm: "0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.06)",
  shadowHover: "0 8px 24px rgba(15, 23, 42, 0.1)",
  radiusLg: 3,
  maxContentWidth: 1400,
  /** @deprecated Used by setup dialog only — prefer solid THEME_PRIMARY for new UI */
  headerBand: "#0d47a1",
  headerHeroGradient:
    "linear-gradient(90deg, #1565c0 0%, #1976d2 100%)",
};
